import * as React from 'react';
import { createBrowserRouter, Navigate } from "react-router-dom";
import Layout from "../layouts/Layout";
import AuthCheck from "../utils/AuthCheck";

import Login from '../pages/authentication/Login';
import ForgotPassword from '../pages/authentication/ForgotPassword';
import OtpVerify from '../pages/authentication/OtpVerify';
import NewPassword from '../pages/authentication/NewPassword';

import StockLevels from '../components/dashboard/Dashboard';

// import ItemRegistration from '../components/itemRegistration/ItemRegistration';
// import ItemRegistrationOutlet from '../components/itemRegistration/ItemRegistrationOutlet';

// import ScanBarcode from '../components/scanBarcode/ScanBarcode';
import PastTransaction from '../components/pastTransaction/PastTransaction';

// import Logistic from '../components/logistic/Logistic';
// import LogisticOutlet from '../components/logistic/LogisticOutlet';
// import LogisticAdd from '../components/logistic/LogisticAdd';
// import LogisticEdit from '../components/logistic/LogisticEdit';

// import Company from '../components/company/Company';
// import CompanyOutlet from '../components/company/CompanyOutlet';
// import CompanyAdd from '../components/company/CompanyAdd';
// import CompanyEdit from '../components/company/CompanyEdit';
// import CompanyView from '../components/company/CompanyView';

// import Warehouse from '../components/warehouse/Warehouse';
// import WarehouseOutlet from '../components/warehouse/WarehouseOutlet';
// import WarehouseAdd from '../components/warehouse/WarehouseAdd';
// import WarehouseEdit from '../components/warehouse/WarehouseEdit';

// import ProductView from '../pages/ProductView';
// import ProductAdd from '../pages/ProductAdd';
// import ProductEdit from '../pages/ProductEdit';
// import ProductDetail from '../pages/ProductDetail';

import NotFound from '../utils/errors/NotFound';

const router = createBrowserRouter([
    {
        path: "/",
        element: <Navigate to="/login" />
    },
    {
        path: "/login",
        element: <Login />
    },
    {
        path: "/resetPassword",
        element: <ForgotPassword />
    },
    {
        path: "/otpVerify",
        element: <OtpVerify />
    },
    {
        path: "/newPassword",
        element: <NewPassword />
    },
    {
        path: "/",
        element: <AuthCheck component={Layout} />,
        children: [
            {
                path: "stocklevels",
                element: <AuthCheck component={StockLevels} />
            },
            // {
            //     path: "itemregistration",
            //     element: < ItemRegistrationOutlet />,
            //     children: [
            //         {
            //             path: "",
            //             element: <AuthCheck component={ItemRegistration} />
            //         }
            //     ]
            // },
            // {
            //     path: "scanbarcode",
            //     element: <AuthCheck component={ScanBarcode} />
            // },
            // {
            //     path: "scanbarcode/:transactionId",
            //     element: <AuthCheck component={ScanBarcode} />
            // },
            {
                path: "pasttransactions",
                element: <AuthCheck component={PastTransaction} />
            },
            // {
            //     path: "logistic",
            //     element: <LogisticOutlet />,
            //     children: [
            //         {
            //             path: "",
            //             element: <AuthCheck component={Logistic} />
            //         },
            //         {
            //             path: "create",
            //             element: <AuthCheck component={LogisticAdd} />
            //         },
            //         {
            //             path: "edit/:id",
            //             element: <AuthCheck component={LogisticEdit} />
            //         },
            //     ]
            // },
            // {
            //     path: "company",
            //     element: <CompanyOutlet />,
            //     children: [
            //         {
            //             path: "",
            //             element: <AuthCheck component={Company} />
            //         },
            //         {
            //             path: "create",
            //             element: <AuthCheck component={CompanyAdd} />
            //         },
            //         {
            //             path: "edit/:id",
            //             element: <AuthCheck component={CompanyEdit} />
            //         },
            //         {
            //             path: "view/:id",
            //             element: <AuthCheck component={CompanyView} />
            //         }
            //     ]
            // },
            // {
            //     path: "warehouse",
            //     element: <WarehouseOutlet />,
            //     children: [
            //         {
            //             path: "",
            //             element: <AuthCheck component={Warehouse} />
            //         },
            //         {
            //             path: "create",
            //             element: <AuthCheck component={WarehouseAdd} />
            //         },
            //         {
            //             path: "edit/:id",
            //             element: <AuthCheck component={WarehouseEdit} />
            //         },
            //     ]
            // },
            // {
            //     path: "productAdd",
            //     element: <AuthCheck component={ProductAdd} />
            // },
            // {
            //     path: "productAdd/:transactionId",
            //     element: <AuthCheck component={ProductAdd} />
            // },
            // {
            //     path: "productView/:id",
            //     element: <AuthCheck component={ProductView} />
            // },
            // {
            //     path: "productEdit/:id",
            //     element: <AuthCheck component={ProductEdit} />
            // },
            // {
            //     path: "productDetails/:transactionId",
            //     element: <AuthCheck component={ProductDetail} />
            // },
            // {
            //     path: "productDetails/:barcode",
            //     element: <AuthCheck component={ProductDetail} />
            // }
        ]
    },
    {
        path: "*",
        element: <NotFound />
    }
]);

export default router;
